import { Loader } from "rsuite";
import "./CustomLoader.css";
import PacmanLoader  from "react-spinners/PacmanLoader";

const CustomLoader = ({ visible }) => {
  if (visible) {
    return (
      <div className="custom-loader">
        <PacmanLoader 
         size={20}
          color="#189f8e"
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }
};
export default CustomLoader;
